var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 9.10156C4.08203 9.10156 3.33203 9.85156 3.33203 10.7682C3.33203 11.6849 4.08203 12.4349 4.9987 12.4349C5.91536 12.4349 6.66536 11.6849 6.66536 10.7682C6.66536 9.85156 5.91536 9.10156 4.9987 9.10156ZM14.9987 9.10156C14.082 9.10156 13.332 9.85156 13.332 10.7682C13.332 11.6849 14.082 12.4349 14.9987 12.4349C15.9154 12.4349 16.6654 11.6849 16.6654 10.7682C16.6654 9.85156 15.9154 9.10156 14.9987 9.10156ZM9.9987 9.10156C9.08203 9.10156 8.33203 9.85156 8.33203 10.7682C8.33203 11.6849 9.08203 12.4349 9.9987 12.4349C10.9154 12.4349 11.6654 11.6849 11.6654 10.7682C11.6654 9.85156 10.9154 9.10156 9.9987 9.10156Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotted);
export default __webpack_public_path__ + "static/media/dotted.5db51fe1da01eb3011a70004316f07e6.svg";
export { ForwardRef as ReactComponent };